import { RuntimeBaseError } from "@/domains/errors/kinds/RuntimeBaseError";

export class RuntimeInitializationError extends RuntimeBaseError {}
